<template>
  <div :id="sliderId" class="product-card-swiper">
    <div
      class="product-card-swiper__wrapper swiper-wrapper"
      :class="!images.length && 'bg--box-overlay'"
    >
      <div
        v-for="(item, i) of images"
        :key="i"
        class="swiper-slide"
      >
        <img
          v-if="imageUrls[item.id]"
          class="product-card-swiper__image swiper-lazy"
          :src="imageUrls[item.id]"
          :alt="item.file_name"
        >

        <div v-else class="swiper-lazy-preloader"/>
      </div>
    </div>

    <div class="product-card-swiper__pagination swiper-pagination flex gap-xxs"/>
  </div>
</template>

<script>
import Swiper, { Pagination, Lazy } from 'swiper'
import mediaService from '@/services/media.service'

Swiper.use([Pagination, Lazy])

export default {
  name: 'ProductCardSwiper',
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    productCardSlider: null,
    imageUrls: {}
  }),
  computed: {
    sliderId () {
      return 'product-card-swiper--' + this._uid
    }
  },
  mounted () {
    if (!this.images?.length) return

    this.productCardSlider = new Swiper(`#${this.sliderId}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      preloadImages: false,
      lazy: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      on: {
        init: () => {
          this.loadImage(0)
        },
        slideChange: () => {
          this.loadImage(this.productCardSlider.activeIndex)
        }
      }
    })
  },
  destroyed () {
    if (!this.productCardSlider) return
    this.productCardSlider.destroy()
  },
  methods: {
    async loadImage (index) {
      const image = this.images[index]

      if (!image || this.imageUrls[image.id]) {
        return
      }

      const url = await mediaService.getObjectUrl(image)

      this.$set(
        this.imageUrls,
        image.id,
        url
      )
    }
  },
  beforeDestroy () {
    this.images.forEach(image => mediaService.revoke(image))
  }
}
</script>
